import * as API from "middleware/api";

export const loadSentRequestsMiddleware = (filters) =>
    API.executeWithAccessToken("debin.load.sentRequests", { ...filters, type: "vendedor" });

export const sendAddAccountsAction = (otp, idAccount, userId) =>
    API.executeWithAccessToken("debin.accounts.addOrRemove", { _otp: otp, idAccount, userId });

export const cancelDebin = (debin) => API.executeWithAccessToken("debin.cancel.sentRequest.send", { ...debin });

export const loadIncomingDebinListMiddleware = (filters) =>
    API.executeWithAccessToken("debin.load.sentRequests", { ...filters, type: "comprador" });

export const removeSellerAccountMiddleware = (idAccount) =>
    API.executeWithAccessToken("debin.seller.accounts.remove", { idAccount });

export const acceptIncomingDebinPreMiddleware = (idDebin) =>
    API.executeWithAccessToken("debin.incoming.accept.pre", { idDebin });

export const createCredinPre = (debin, recipients) =>
    API.executeWithAccessToken("credin.create.preview", { ...debin, recipients });

export const createCredin = (otp, debin, recipients, id, cbuList) =>
    API.executeWithAccessToken("credin.sentRequest.send", { _otp: otp, ...debin, recipients, id, cbuList });

export const loadSellerDebinDetail = (idDebin) => API.executeWithAccessToken("debin.seller.detail", { idDebin });

export const createDebin = (newDebinRequest) => API.executeWithAccessToken("debin.create.send", { ...newDebinRequest });

export const createDebinPre = (debinData) => API.executeWithAccessToken("debin.create.preview", { ...debinData });

export const acceptIncomingDebinSendMiddleware = (debin) =>
    API.executeWithAccessToken("debin.incoming.accept.send", { ...debin });

export const declineIncomingDebinSendMiddleware = (debin) =>
    API.executeWithAccessToken("debin.incoming.decline.send", { ...debin });

export const exportIncomingDebinTicket = (
    creationDate,
    idVoucher,
    debitAccount,
    sellerAccount,
    sellerCbu,
    sellerDocumentType,
    sellerDocumentNumber,
    sellerTitle,
    sellerBank,
    reference,
    amountCurrency,
    amountQuantity,
    concept,
    expirationDate,
    description,
    idDebin,
) =>
    API.executeWithAccessToken("/export.incoming.debin.ticket", {
        creationDate,
        idVoucher,
        debitAccount,
        sellerAccount,
        sellerCbu,
        sellerDocumentType,
        sellerDocumentNumber,
        sellerTitle,
        sellerBank,
        reference,
        amountCurrency,
        amountQuantity,
        concept,
        expirationDate,
        description,
        idDebin,
    });

export const exportTermsAndConditions = (format, dummy) =>
    API.executeAnonymous("/session.exportTermsAndConditions", { format, dummy });

export const getSeller = (seller, userId) => API.executeWithAccessToken("/get.debin.seller", { seller, userId });

export const relateBuyerToRecurrency = (debinPrestacion) =>
    API.executeWithAccessToken("/load.debin.recurrency", { ...debinPrestacion });

export const getRecurrencies = (form) => API.executeWithAccessToken("/debin.recurrency.list", { ...form });

export const setUpdateRecurrencyState = (debin, userId) =>
    API.executeWithAccessToken("/change.status.debin.recurrency", { ...debin, userId });

export const listConcepts = () => API.executeWithAccessToken("/debin.create.pre");

export const addNewVendorAccountRequest = (debin) =>
    API.executeWithAccessToken("/debin.accounts.addOrRemove", { ...debin });

export const removeVendorAccountRequest = (debin) =>
    API.executeWithAccessToken("/debin.seller.accounts.remove", { ...debin });

export const accountInfoByCbuCvuAlias = (params) =>
    API.executeWithAccessToken("/read.third.party.account", { ...params });

export const listCredentialsGroupsMidle = (params) =>
    API.executeWithAccessToken("/core.listTransactionCredentialsGroups", params);

export const scheduledDebinListMidle = (form) => API.executeWithAccessToken("/debin.scheduled.list", { ...form });

export const acceptScheduledDebinSendMid = (params) =>
    API.executeWithAccessToken("/debin.scheduled.accept.send", { ...params });

export const rejectScheduledDebinSendMid = (params) =>
    API.executeWithAccessToken("/debin.scheduled.reject.send", { ...params });

export const pauseScheduledDebinSendMid = (params) =>
    API.executeWithAccessToken("/debin.scheduled.pause.send", { ...params });

export const cancelScheduledDebinSendMid = (params) =>
    API.executeWithAccessToken("/debin.scheduled.cancel.send", { ...params });

export const activateScheduledDebinSendMid = (params) =>
    API.executeWithAccessToken("/debin.scheduled.activate.send", { ...params });

export const chargeBackSendMiddleware = (params) => API.executeWithAccessToken("/debin.chargeBack.send", { ...params });

export const chargeBackTrxPlSend = (params) => API.executeWithAccessToken("/trxpl.chargeBack.send", { ...params });
